<div class="card border-0 shadow-sm h-100">
  <div class="card-header bg-white border-bottom-0 text-center">
    <h5 class="card-title text-muted mb-0">{{ 'DASHBOARD.ROLES_DISTRIBUTION' | translate }}</h5>
  </div>
  <div class="card-body d-flex align-items-stretch justify-content-center align-items-center">
    @if (isLoading) {
      <div class="w-100 text-center py-5">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">{{ 'COMMON.LOADING' | translate }}</span>
        </div>
      </div>
    } @else {
      @if (!errorMessage) {
        <p-chart
          class="role-distribution-chart"
          type="pie"
          [data]="data"
          [options]="options"
          style="width:100%;display:block;"
        ></p-chart>
      } @else {
        <div class="w-100 text-center py-5 text-danger">
          {{ errorMessage | translate }}
        </div>
      }
    }
  </div>
</div>